import { set } from 'lodash-es';

export default {
  props: {
    customPiplStatement: {
      type: String,
      default: '',
    },
    shouldDisplayChinesePiplStatement: {
      type: Boolean,
      default: false,
    },
    customConsentInnerClass: {
      type: String,
      default: '',
    },
    customConsentOuterClass: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      allowedForms: [
        'accountCreation',
        'boutiqueAppointment',
        'contact',
        'gep',
        'lightCheckout',
        'newsletter',
        'payment',
        'personalInformation',
      ],
      hasConsentedToChinesePipl: false,
      chinesePiplConsents: {
        cbdt: false,
        privacyPolicy: false,
      },
    };
  },

  computed: {
    piplStatement() {
      if (this.customPiplStatement) {
        return this.customPiplStatement;
      }

      if (!this.formType) {
        return this.$t('Form.piplStatement');
      }

      return this.$t(`Form.piplStatement.${this.formType}`);
    },

    shouldDisplayChinesePIPL() {
      return window.Cookies.get('currentCountry') === 'CN';
    },

    shouldDisplayPIPLConsentCheckboxes() {
      return this.shouldDisplayChinesePIPL && this.allowedForms.includes(this.formType);
    },

    shouldDisplayPIPLStatement() {
      return this.shouldDisplayChinesePIPL && this.shouldDisplayChinesePiplStatement === true;
    },
  },

  methods: {
    onChinesePiplConsentChange(hasConsented) {
      this.hasConsentedToChinesePipl = hasConsented.hasConsentedToChinesePipl;
      this.chinesePiplConsents.cbdt = hasConsented.cbdt;
    },

    getChinesePiplFormData() {
      return this.shouldDisplayPIPLConsentCheckboxes ? { cbdtConsent: this.chinesePiplConsents.cbdt } : {};
    },

    setCustomerCbdtConsentInForm(customerInfo) {
      if (customerInfo !== null && customerInfo.hasOwnProperty('cbdtConsent')) {
        set(this.chinesePiplConsents, 'cbdt', customerInfo.cbdtConsent);
      }
    },
  },
};
